import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class ProcessingError extends EluveError {
  static override readonly errorName = 'ProcessingError';
  readonly logLevel: LogLevel = 'error';

  constructor(message = 'Processing failed', args?: EluveErrorArgs) {
    super(message, args);
  }
}
